export function setUser(state, user) {
   state.user = user
   state.is_logged = true
}

export function setSpecialCustomerValue(state, val) {
  state.special_customer = val
  state.is_logged = true
}

export function setStateAccessToken(state, token) {
  state.access_token = token;
}

export function setLoadCSF(state, val) {
  state.is_csf = val;
}

 export function cleanSession(state) {
   state.user = null
   state.is_logged = false
   state.access_token = null
   state.logged_at = null
   state.is_csf = false
 }
 